var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-display-box"},[_c('div',{staticClass:"grey--text text--darken-1 font-weight-bold"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"grey--text text--darken-3"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }